import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  Label,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import QuestionPage from '../views/QuestionPage/';
import AddQuestion from './AddQuestion';
import EditQuestion from './EditQuestion';
import CKEditor from 'ckeditor4-react';
const GLOBAL = require('../Globals');

class Questions extends Component {
	 
	/** set property value **/
	constructor(props){
		super(props);
		MathJax.Hub.Config({
            tex2jax: {
                inlineMath: [['$', '$'], ['\\(', '\\)']],
                displayMath: [['$$', '$$'], ['\\[', '\\]']],
                jax: ["input/TeX", "input/MathML", "input/AsciiMath", "output/HTML-CSS", "output/NativeMML", "output/PreviewHTML"],
            },
            "HTML-CSS": {
                webFont: "TeX",
                automatic: false,
                matchFontHeight: true,
            },
            showMathMenu: false,
        });
		this.state = {
			idd : '',
			acyear : '',
			cls : '',
			section : '',
			value : [],
			type : '',
			suborder : '',
			subje : '',
			stype : '',
			sorder : '',
			isdisplay : 0,
			_message : '',
			alertClass :'',
			posts : [],
			secs : [],
			accyear : [],
			subj : [],
			_redirect : false,
			subject :[],
			modal: false,
			assub : [],
			data : [],
			data1 : [],
			editData : [],
			editImg : [],
			books : [],
			imgdata : [],
			lessons :[],
			isbtnview : false,
			addmodal : false,
			editmodal : false,
			insmodal : false,
			isview : false,
			currentPage: 1,
			todosPerPage: 10,
			activePage : 1,
		}
		this.handlePageChange = this.handlePageChange.bind(this);
		this.getdata = this.getdata.bind(this);
		this.onClsChange = this.onClsChange.bind(this);
		this.onacChange = this.onacChange.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onSubChange = this.onSubChange.bind(this);
		this.onSearchChange = this.onSearchChange.bind(this);
		this.onViewClick = this.onViewClick.bind(this);
	}

	onLessonChange(e){
		this.setState({ currentPage: 1, activePage: 1 });
		if(e.target.value == ''){
			this.setState({ data: this.state.data1 });
		}
		else{
			let ndata = this.state.data1.filter(function (obj) {
				return(obj.lesson == e.target.value);
			});
			this.setState({ data: ndata });
		}
	}

	onSearchChange(e){
		this.setState({ currentPage: 1, activePage: 1});
		let ndata = this.state.data1.filter(function (item) {
			const bookname = item.bookname.toUpperCase();
			const lessonname = item.lessonname.toUpperCase();
			const question = item.question.toUpperCase();
			const option1 = item.option1.toUpperCase();
			const option2 = item.option2.toUpperCase();
			const option3 = item.option3.toUpperCase();
			const option4 = item.option4.toUpperCase();
			const s = e.target.value.toUpperCase();
			return (bookname.indexOf(s) > -1 || lessonname.indexOf(s) > -1 || question.indexOf(s) > -1 || option1.indexOf(s) > -1 || option2.indexOf(s) > -1 || option3.indexOf(s) > -1 || option4.indexOf(s) > -1);
		});
		this.setState({ data: ndata });
	}

	onAddClick(e){
		this.setState({addmodal : !this.state.addmodal});
	}

	onSubChange(e){
		this.state.subname = $("#sub").find(":selected").attr("data-name");
		this.setState({sub : e.target.value,data : [],isbtnview : true,isview : false});
		this.getlesson();
	}

	onViewClick(e){
		this.getdata();
	}
	
	onacChange(e){
		$("#clas").val('');
		$("#sub").val('');
		this.setState({[e.target.name]:e.target.value,data : [],isbtnview : false,isview : false});
	}
	
	onClsChange(e){
		$("#sub").val('');
		this.state.clsname = $("#clas").find(":selected").attr("data-name");
		this.setState({[e.target.name]:e.target.value,data : [],isbtnview : false,isview : false});
		this.getsubject();
	}

	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		
		if (window.confirm("Do you want to Delete?")) { 
			$("#showLoader").show();
			GetData('question/deletequestion/'+this.state.id).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Question Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Question',
						alertClass:'alert alert-danger'
					});
				}
			});
		}		
	}

	onUpdate(id){
		var dat = this.state.data.filter(function(obj){
			return (obj.id == id);
		})
		var img = this.state.imgdata.filter(function(obj){
			return (obj.question == id);
		})
		this.setState({editData : dat[0],editImg : img,id : id,editmodal : true});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
		this.getclass();
		this.getbooks();
		MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    }

    componentDidUpdate() {
        $("span.math-tex").closest("p").css("display", "inline");
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
			}
		});
	}
	
	getbooks() {
		$("#showLoader").show();
		GetData('question/getbooks').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					books: responseJson
				});
			}
		});
	}

	getlesson() {
		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sub = $("#sub").val();
		$("#showLoader").show();
		GetData('question/getlessonsbysub/'+ac+'/'+cls+'/'+sub).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					lessons: responseJson
				});
			}
		});
	}

	getsubject(){
		
		var ac = $("#year").val();
		var cls = $("#clas").val();
		$("#showLoader").show();
		if(this.state.userRole == 'admin'){
			GetData('assignsubject/getsubbycls/'+ac+'/'+cls).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson){
					this.setState({
						subject : responseJson
					});
				}
			});
		}
		else if(this.state.userRole == 'questionbank'){
			GetData('assignsubject/getsubbystaff/'+ac+'/'+cls+'/'+this.state.staffid).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson){
					this.setState({
						subject : responseJson
					});
				}
			});
		}
	}

	getdata(){
		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sub = $("#sub").val();
		this.setState({addmodal : false,editmodal : false});
		$("#showLoader").show();
		GetData('question/getquestionbycls/'+ac+'/'+cls+'/'+sub).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == 1){
				this.setState({
					data : responseJson.data,
					data1 : responseJson.data,
					imgdata : responseJson.imgdata,
					isview : true
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}

	getAnswer(id){
		var d = this.state.data;
		var result = [];
		var index = d.findIndex(function(obj){
			return(obj.id == id);
		});
		var image = '';
		if(d[index].answer == 'option1'){
			image = d[index].optimage1;
		}
		else if(d[index].answer == 'option2'){
			image = d[index].optimage2;
		}
		else if(d[index].answer == 'option3'){
			image = d[index].optimage3;
		}
		else if(d[index].answer == 'option4'){
			image = d[index].optimage4;
		}
		if(index >-1){
			var answer = d[index].answer;
			if(image!='' && image!=null){
				result.push(<React.Fragment>
					<div dangerouslySetInnerHTML={{ __html: d[index][answer] }}></div>
					<img src={GLOBAL.BASE_URL+image} />
				</React.Fragment>);
			}
			else{
				result.push(<div dangerouslySetInnerHTML={{ __html: d[index][answer] }}></div>);
			}
		}
		return result;
	}

	getImageQuestion(id){
		var d = this.state.imgdata;
		var image = [];
		for(var i=0;i<d.length;i++){
			if(d[i].question == id){
				image.push(<img src={GLOBAL.BASE_URL+d[i].image} />);
			}
		}
		return image;
	}
	
  render() {
	
	var items = this.state.posts;
	var acyear = this.state.accyear;

	let userData = JSON.parse(sessionStorage.getItem('userData'));
	this.state.userId = userData['userid'];
	this.state.userRole = userData['userrole'];
	this.state.staffid = userData['staffid'];
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.data.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
		return <tr>
			<td>{indexOfFirstTodo+i+1}</td>
			<td>{item.bookname}</td>
			<td>{item.lessonname}</td>
			<td><div dangerouslySetInnerHTML={{ __html: item.question }}></div>
				{this.getImageQuestion(item.id)}
			</td>
			<td><div dangerouslySetInnerHTML={{ __html: item.option1 }}></div>
				{item.optimage1!='' && item.optimage1!=null ? 
				<img src={GLOBAL.BASE_URL+item.optimage1} /> : ''}
			</td>
			<td><div dangerouslySetInnerHTML={{ __html: item.option2 }}></div>
				{item.optimage2!='' && item.optimage2!=null ? 
				<img src={GLOBAL.BASE_URL+item.optimage2} /> : ''}
			</td>
			<td><div dangerouslySetInnerHTML={{ __html: item.option3 }}></div>
				{item.optimage3!='' && item.optimage3!=null ? 
				<img src={GLOBAL.BASE_URL+item.optimage3} /> : ''}
			</td>
			<td><div dangerouslySetInnerHTML={{ __html: item.option4 }}></div>
				{item.optimage4!='' && item.optimage4!=null ? 
				<img src={GLOBAL.BASE_URL+item.optimage4} /> : ''}
			</td>
			<td>{this.getAnswer(item.id)}</td>
			<td>
				<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} data-toggle="tooltip" data-placement="top" title="Edit"><i className="fa fa-edit"></i></button>
				&nbsp;&nbsp;
				<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} data-toggle="tooltip" data-placement="top" title="Delete"><i className="fa fa-remove"></i></button>
			</td>
		</tr>;
	});

    return (
		<div>
		  <QuestionPage />
			<div className="animated fadeIn" style={{marginTop : '45px'}}>
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card >
						<CardHeader style={{position: 'fixed',width: '80.6%',zIndex: '9',backgroundColor : '#20a8d8',color : '#FFF'}}>
							<strong>Questions</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<select name="acyear" onChange={this.onacChange} required id="year">
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							</select>&emsp;
							<select name="cls" onChange={this.onClsChange} id="clas" required > 
								<option value="">Select Class</option>
								{
									items.map(function (item) {
										return <option value={item.id} data-name={item.class}>{item.class}</option>;
									})
								}
							</select>&emsp;
							<select name="sub" onChange={this.onSubChange} id="sub" required > 
								<option value="">Select Subject</option>
								{
									this.state.subject.map(function (item) {
										return <option value={item.subject} data-name={item.sub}>{item.sub}</option>;
									})
								}
							</select>&emsp;
							{this.state.isbtnview ?
								<React.Fragment>
									<button className="btn btn-warning btn-md" onClick={this.onViewClick}>View</button>&emsp;
									<button className="btn btn-danger btn-md" onClick={this.onAddClick.bind(this)}>Add</button>
								</React.Fragment>
							: ''}&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
							{this.state.isview ? 
								<select name="lesson" onChange={this.onLessonChange.bind(this)}>
									<option value="">Filter By Lesson</option>
									{
										this.state.lessons.map(function (item) {
											return <option value={item.id}>{item.lesson}</option>;
										})
									}
								</select>
							: ''}
							<input name="search" style={{float : 'right'}} onChange={this.onSearchChange} placeholder="Search..." />
						</CardHeader>
						<CardBody id="asubbody">
							{this.state.isview ?
							<Row style={{marginTop : '30px'}}>
								<Col md="12" style={{marginTop : '25px'}}>
									<span style={{float : 'right'}}>Show <b>{this.state.data.length}</b> Records</span>
									<Table responsive bordered >
										<thead>
											<tr>
												<th>S.No</th>
												<th>Book</th>
												<th>Lesson</th>
												<th>Question</th>
												<th>Option 1</th>
												<th>Option 2</th>
												<th>Option 3</th>
												<th>Option 4</th>
												<th>Answer</th>
												<th>Manage</th>
											</tr>
										</thead>
										<tbody>
											{renderTodos}<br />
										</tbody>
									</Table>
								</Col>
								<Col md={12}>
									<Pagination
										activePage={this.state.activePage}
										itemsCountPerPage={this.state.todosPerPage}
										pageRangeDisplayed={3}
										totalItemsCount={this.state.data.length}
										onChange={this.handlePageChange}
									/>
								</Col>
						  	</Row> : ''}
							<Modal isOpen={this.state.addmodal} size="lg" toggle={this.onAddClick} className={this.props.className}>
								<ModalHeader toggle={()=>{this.setState({addmodal : false})}}>Add Question - {this.state.clsname} - {this.state.subname}
									<span style={{float : 'right'}}><button class="btn btn-warning" onClick={()=>{this.setState({insmodal : !this.state.insmodal})}}>Instruction</button></span>
								</ModalHeader>
								<ModalBody>
									<AddQuestion afterFinish={this.getdata} cancelClick={()=>{this.setState({addmodal : false})}} acyear={this.state.acyear} cls={this.state.cls} sub={this.state.sub} />
								</ModalBody>
							</Modal>
							<Modal isOpen={this.state.editmodal} size="lg" toggle={this.getdata} className={this.props.className}>
								<ModalHeader toggle={()=>{this.setState({editmodal : false})}}>Edit Question
									<span style={{float : 'right'}}><button class="btn btn-warning" onClick={()=>{this.setState({insmodal : !this.state.insmodal})}}>Instruction</button></span>
								</ModalHeader>
								<ModalBody>
									<EditQuestion afterFinish={this.getdata} cancelClick={()=>{this.setState({editmodal : false})}} data={this.state.editData} img={this.state.editImg} id={this.state.id} />
								</ModalBody>
							</Modal>

							<Modal isOpen={this.state.insmodal} size="lg" toggle={()=>{this.setState({insmodal : !this.state.insmodal})}} className={this.props.className}>
								<ModalHeader toggle={()=>{this.setState({insmodal : false})}}>Instructions</ModalHeader>
								<ModalBody>
									<Row>
										<Col md={12}>
											<ul style={{color : 'green'}}>
												<li>Mandatory fields are marked as <span className="text-danger">*</span></li>
												<li>When the option is (Yes or No) please put Option1 is Yes and Option2 is No</li>
												<li>For Mathematical & Chemical equations press to On Math Editor button and use sigma ( &Sigma; ) symbol in the editor.(Documentaion Link  - <a target="_blank" href="https://en.wikibooks.org/wiki/LaTeX/Mathematics">https://en.wikibooks.org/wiki/LaTeX/Mathematics</a>) </li>
												<li>For Tamil Questions use this link <a target="_blank" href="https://www.google.com/intl/ta/inputtools/try/">https://www.google.com/intl/ta/inputtools/try/</a><br />
												(You need to type tamil questions in this link and just Copy paste in the question box)</li>
												<li>Don't use Bamini Font</li>
											</ul>
										</Col>
									</Row>
								</ModalBody>
							</Modal>
							
						</CardBody>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Questions;


// WEBPACK FOOTER //
// ./src/Questions/Questions.js